module.exports = __webpack_public_path__ + "img/free-boxes.21fe0074.svg";